
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/gearfocus-facts",
      function () {
        return require("private-next-pages/about/gearfocus-facts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/gearfocus-facts"])
      });
    }
  